module.exports = __webpack_public_path__ + "img/1.5ff8d2c2.png";